import { Quadrant } from './../../reaction-set/reaction-set-enums';
import { Channel } from './channel';
import { GeneTest, Result } from './result';
export class CovidSamples {
    barcode : string;
    positionRow : number;
    positionCol : number;
    cpValue : number;
    originalResult: string;
    inValidResult : boolean;
    comments : string;
    quadrant: Quadrant;
    contaminationType: string;
    twoSwabsComment: string;
    defaultContaminationComment: string;
    boxId: string;
    receivedBatchID: string;
    channels: Channel[];
    results: Result[] = [];
    nonConformanceProblem: string;
    documentBarcode:string;
    customersBarcode:string;
    icrChannelUpdateIndex: number;
    icrChannelUpdateResult: boolean;
    unboxedSender: string;
    singleSampleRedo: boolean;
    archiveSlot: number;
    cyclerManufacturer: string;
    extractorManufacturer: string;
    archievePositionRow: number;
    archievePositionCol: number;
    singleSampleInconclussiveRedo: boolean;
    singleSampleTechnicalRedo: boolean;
    destination: string;
    shippedUserPUID: string;
    shippedTimestamp: Date;
    externalResult: string;
    externalResultCompletionDate: Date;
    sampleType:string;
    parentBatchID: string;
    delivery: string;
    order: string[];
    tests: GeneTest[];
    result: Map<string,any>;
    orderStatus: string;
}

export class MachineShortInfo {
    machineName : string;
    machineBarcode : string;
    subType : string;
}
